module.exports = __webpack_public_path__ + "media/images/badges/rumble/milestone-1000-Active-Rumble-4aa30f948c15cd2121057d57255eaf1a.png";